(function () {
  if (window.__pnPackListo) { return; }
  window.__pnPackListo = true;

  /* ============================================================
     INTERRUPTOR GENERAL DE LOS PACKS

     false = NINGUNA ficha muestra packs. Se deja el formulario nativo del
             tema (tallas + boton), igual en toda la tienda.
     true  = vuelven los packs de 1/2/3 unidades, y entonces manda la lista
             SIN_PACK de abajo para excluir fichas sueltas.

     Puesto en false el 13 ago 2026 a peticion suya: quitar los packs de
     todas las prendas. Para revertirlo, poner true y ya esta: el resto del
     fichero se ha dejado intacto.
     ============================================================ */
  var PACKS_ACTIVOS = false;

  // Fichas que NO llevan packs (solo aplica si PACKS_ACTIVOS es true).
  var SIN_PACK = [
    'federica-vestido-largo-y-encaje-marron',
    'alessia-mono-largo-de-pierna-ancha',
    'gregoria-vestido-largo-floral-escote-profundo'
  ];

  var TIERS = [
    { n: 1, off: 0, sub: 'Pruébalo', badge: null },
    { n: 2, off: 0.15, sub: 'Ahorra 15%', badge: 'MÁS ELEGIDO' },
    { n: 3, off: 0.20, sub: 'Ahorra 20%', badge: 'MÁS AHORRO' }
  ];

  function eur(cents) { return '€' + (Math.round(cents) / 100).toFixed(2).replace('.', ','); }
  function norm(s) { return (s || '').toString().trim().toLowerCase(); }

  // Sincroniza la galeria con los colores elegidos.
  var __pnGalUltimo;
  function pnSyncGaleria(colores) {
    var lista = (colores && colores.length) ? colores.map(norm) : null;
    var clave = lista ? lista.slice().sort().join('|') : '__all__';
    if (clave === __pnGalUltimo) { return; }
    var els = document.querySelectorAll('.producto-nazalea__foto, .producto-nazalea__mini');
    if (!els.length) { return; }
    __pnGalUltimo = clave;
    var primeraMini = null;
    Array.prototype.forEach.call(els, function (f) {
      var dc = f.getAttribute('data-color');
      if (!dc) { var im = f.querySelector('img'); dc = im ? im.alt : ''; }
      dc = norm(dc);
      var match = !lista || lista.some(function (cc) {
        return dc && (dc === cc || cc.indexOf(dc) === 0 || dc.indexOf(cc) === 0);
      });
      f.style.display = match ? '' : 'none';
      if (match && !primeraMini && f.className.indexOf('__mini') !== -1) { primeraMini = f; }
    });
    var cont = document.querySelector('.producto-nazalea__fotos');
    if (cont) { cont.scrollLeft = 0; }
    Array.prototype.forEach.call(document.querySelectorAll('.producto-nazalea__mini'), function (mm) { mm.classList.remove('producto-nazalea__mini--activa'); });
    if (primeraMini) { primeraMini.classList.add('producto-nazalea__mini--activa'); }
  }

  function init() {
    if (!PACKS_ACTIVOS) { return; }   // <-- interruptor general
    var form = document.querySelector('.producto-nazalea__form');
    if (!form || document.querySelector('.pn-pack')) { return; }
    var hm = location.pathname.match(/\/products\/([^/?#]+)/);
    if (!hm) { return; }
    if (SIN_PACK.indexOf(hm[1]) !== -1) { return; }
    fetch('/products/' + hm[1] + '.js')
      .then(function (r) { return r.json(); })
      .then(function (P) { build(P, form); })
      .catch(function () {});
  }

  function build(P, form) {
    var names = P.options || [];
    var colorIdx = -1, sizeIdx = -1, i;
    for (i = 0; i < names.length; i++) {
      var nm = norm(names[i].name || names[i]);
      if (/color/.test(nm) && colorIdx < 0) { colorIdx = i; }
      else if (/(talla|size)/.test(nm) && sizeIdx < 0) { sizeIdx = i; }
    }
    if (sizeIdx < 0 && names.length > 1) { sizeIdx = colorIdx === 0 ? 1 : 0; }

    var variants = P.variants || [];
    function vopt(v, idx) { return (v.options && v.options[idx] != null) ? v.options[idx] : (v['option' + (idx + 1)]); }

    var colors = [], sizes = [];
    for (i = 0; i < variants.length; i++) {
      var c = colorIdx >= 0 ? vopt(variants[i], colorIdx) : null;
      var s = sizeIdx >= 0 ? vopt(variants[i], sizeIdx) : null;
      if (c != null && colors.indexOf(c) === -1) { colors.push(c); }
      if (s != null && sizes.indexOf(s) === -1) { sizes.push(s); }
    }
    var media = P.media || [];
    function fotoColor(color) {
      var cc = norm(color), j;
      for (j = 0; j < media.length; j++) { if (media[j].src && cc.indexOf(norm(media[j].alt)) === 0 && norm(media[j].alt)) { return media[j].src; } }
      for (j = 0; j < media.length; j++) { var a = norm(media[j].alt); if (media[j].src && a && cc.indexOf(a) !== -1) { return media[j].src; } }
      return (P.featured_image || (media[0] && media[0].src) || '');
    }
    function variantId(color, size) {
      for (var k = 0; k < variants.length; k++) {
        var okC = colorIdx < 0 || vopt(variants[k], colorIdx) === color;
        var okS = sizeIdx < 0 || vopt(variants[k], sizeIdx) === size;
        if (okC && okS) { return variants[k].id; }
      }
      return null;
    }

    var unit = P.price;
    var estado = { qty: 1, sel: [] };
    for (i = 0; i < 3; i++) { estado.sel.push({ color: colors[0] || null, size: sizes[0] || null }); }

    var wrap = document.createElement('div');
    wrap.className = 'pn-pack';

    var tiers = document.createElement('div');
    tiers.className = 'pn-pack__tiers';
    TIERS.forEach(function (t) {
      var total = Math.round(unit * t.n * (1 - t.off));
      var card = document.createElement('button');
      card.type = 'button';
      card.className = 'pn-pack__tier';
      card.setAttribute('data-n', t.n);
      var badge = t.badge ? '<span class="pn-pack__badge">' + t.badge + '</span>' : '';
      var antes = t.off > 0 ? '<s>' + eur(unit * t.n) + '</s> ' : '';
      card.innerHTML = badge +
        '<span class="pn-pack__tier-n">' + t.n + (t.n === 1 ? ' unidad' : ' unidades') + '</span>' +
        '<span class="pn-pack__tier-precio">' + antes + '<strong>' + eur(total) + '</strong></span>' +
        '<span class="pn-pack__tier-sub">' + t.sub + '</span>';
      card.addEventListener('click', function () { estado.qty = t.n; render(); });
      tiers.appendChild(card);
    });
    wrap.appendChild(tiers);

    var units = document.createElement('div');
    units.className = 'pn-pack__units';
    wrap.appendChild(units);

    var add = document.createElement('button');
    add.type = 'button';
    add.className = 'pn-pack__add';
    wrap.appendChild(add);

    function render() {
      Array.prototype.forEach.call(tiers.children, function (c) {
        c.classList.toggle('is-sel', parseInt(c.getAttribute('data-n'), 10) === estado.qty);
      });
      units.innerHTML = '';
      for (var u = 0; u < estado.qty; u++) {
        (function (u) {
          var row = document.createElement('div');
          row.className = 'pn-pack__unit';
          var etiqueta = estado.qty > 1 ? '<div class="pn-pack__unit-tit">Prenda ' + (u + 1) + '</div>' : '';
          var sw = colors.map(function (col) {
            var act = estado.sel[u].color === col ? ' is-sel' : '';
            return '<button type="button" class="pn-pack__swatch' + act + '" data-color="' + encodeURIComponent(col) + '" title="' + col + '" aria-label="' + col + '"><img src="' + fotoColor(col).split('?')[0] + '?width=90" alt=""></button>';
          }).join('');
          var sz = sizes.map(function (s) {
            var act = estado.sel[u].size === s ? ' is-sel' : '';
            return '<button type="button" class="pn-pack__size' + act + '" data-size="' + encodeURIComponent(s) + '">' + s + '</button>';
          }).join('');
          row.innerHTML = etiqueta +
            (colors.length ? '<div class="pn-pack__row"><span class="pn-pack__lab">Color</span><div class="pn-pack__colors">' + sw + '</div></div>' : '') +
            (sizes.length ? '<div class="pn-pack__row"><span class="pn-pack__lab">Talla</span><div class="pn-pack__sizes">' + sz + '</div></div>' : '');
          units.appendChild(row);
          Array.prototype.forEach.call(row.querySelectorAll('.pn-pack__swatch'), function (b) {
            b.addEventListener('click', function () { estado.sel[u].color = decodeURIComponent(b.getAttribute('data-color')); render(); });
          });
          Array.prototype.forEach.call(row.querySelectorAll('.pn-pack__size'), function (b) {
            b.addEventListener('click', function () { estado.sel[u].size = decodeURIComponent(b.getAttribute('data-size')); render(); });
          });
        })(u);
      }
      var total = Math.round(unit * estado.qty * (1 - TIERS[estado.qty - 1].off));
      add.innerHTML = 'AÑADIR A LA CESTA · <strong>' + eur(total) + '</strong>';
      var colores = [];
      for (var q = 0; q < estado.qty; q++) {
        var cv = estado.sel[q].color;
        if (cv && colores.indexOf(cv) === -1) { colores.push(cv); }
      }
      pnSyncGaleria(colores);
    }

    add.addEventListener('click', function () {
      var items = [];
      for (var u = 0; u < estado.qty; u++) {
        var id = variantId(estado.sel[u].color, estado.sel[u].size);
        if (!id) { units.children[u] && units.children[u].classList.add('pn-pack__unit--err'); return; }
        items.push({ id: id, quantity: 1 });
      }
      add.disabled = true;
      var prev = add.innerHTML;
      add.innerHTML = 'AÑADIENDO…';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { if (!r.ok) { throw new Error('add'); } return r.json(); })
        .then(function () { return fetch(location.pathname, { headers: { Accept: 'text/html' } }); })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          try {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresco = doc.querySelector('#cart-drawer .cart-drawer__inner');
            var actual = document.querySelector('#cart-drawer .cart-drawer__inner');
            if (fresco && actual) { actual.replaceWith(fresco); }
          } catch (e) {}
          add.disabled = false; add.innerHTML = prev;
          var d = document.querySelector('#cart-drawer');
          if (d && typeof d.open === 'function') { d.open(); } else { location.href = '/cart'; }
        })
        .catch(function () { add.disabled = false; add.innerHTML = prev; location.href = '/cart'; });
    });

    // El aviso de escasez vive DENTRO del form original y al ocultarlo
    // desaparecia. Se saca y se coloca justo sobre el boton.
    var aviso = form.querySelector('.producto-nazalea__aviso');
    if (aviso) {
      aviso.style.setProperty('margin-top', '28px', 'important');
      wrap.insertBefore(aviso, add);
    }

    form.style.display = 'none';
    form.insertAdjacentElement('beforebegin', wrap);
    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();